export const env = {
  apiBaseUrl: '#{api_base_url}#',
}

// export const env = {
//   apiBaseUrl: 'https://feature-flag-api.dev.autovinlive.com',
// }

export const CONSTANTS = {
    DEV: 'DEV',
    DEVINT: 'DEVINT',
    TEST: 'TEST',
    SIT: 'SIT',
    PROD: 'PROD'
}